// extracted by mini-css-extract-plugin
export var actions = "_sy-4";
export var item = "_sy-1";
export var price = "_sy-3";
export var quantity = "_sy-2";
export var table = "_sy-0";